import { apiCallJson } from './auth';
import { getRuntimeOrigin } from '../../utils/runtimeUrls';

// API 설정
const API_CONFIG = {
  // 개발 환경
  development: {
    baseURL: '',
    wsURL: ''
  },
  // 프로덕션 환경
  production: {
    baseURL: '',
    wsURL: getRuntimeOrigin()
  }
};

// API 엔드포인트 정의
export const ENDPOINTS = {
  STATISTICS: {
    MANUAL_RESERVATIONS_OVERVIEW: '/api/statistics/manual-reservations/overview',
    MANUAL_RESERVATIONS_BY_TYPE: '/api/statistics/manual-reservations/by-type',
    MANUAL_RESERVATIONS_PRICING: '/api/statistics/manual-reservations/pricing',
    MANUAL_RESERVATIONS_DEPOSITS: '/api/statistics/manual-reservations/deposits',
    MANUAL_RESERVATIONS_TIMELINE: '/api/statistics/manual-reservations/timeline',
    MANUAL_RESERVATIONS_CUSTOMERS: '/api/statistics/manual-reservations/customers',
    MANUAL_RESERVATIONS_MONTHLY_SUMMARY: '/api/statistics/manual-reservations/monthly-summary',
    MANUAL_RESERVATIONS_YEARLY_SUMMARY: '/api/statistics/manual-reservations/yearly-summary',
    PERIOD_OPTIONS: '/api/statistics/period-options'
  }
};

// 현재 환경에 따른 설정
const currentEnv = process.env.NODE_ENV || 'development';
const config = API_CONFIG[currentEnv];

// API 기본 URL
export const API_BASE_URL = config.baseURL;

// WebSocket URL
export const WS_URL = config.wsURL;

// API 호출 헬퍼 함수
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;

  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    credentials: 'include',
    ...options
  };

  const response = await fetch(url, defaultOptions);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// 인증 헤더가 포함된 API 호출
export const apiCallWithAuth = async (endpoint, options = {}) => {
  return apiCallJson(`${API_BASE_URL}${endpoint}`, options);
};

const apiConfig = {
  API_BASE_URL,
  WS_URL,
  apiCall,
  apiCallWithAuth,
  ENDPOINTS
};

export default apiConfig;
